import KebabMenu from "./KebabMenu";
import ThemeToggle from "./ThemeToggle";

const TopBar = () => {
  return (
    <header className="topbar">
      <div className="wrap topbar__inner">
        <a className="wordmark" href="#top" aria-label="StreamLover home">
          StreamL
          <span className="o" aria-hidden="true" />
          ver
        </a>
        <div className="topbar__actions">
          <ThemeToggle />
          <a className="btn" href="/beta">
            Start listening
          </a>
          <KebabMenu />
        </div>
      </div>
    </header>
  );
};

export default TopBar;
